var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15113 5.83334H8.84913C9.4238 5.83334 9.72913 5.15335 9.34713 4.72335L5.49847 0.393345C5.43604 0.322882 5.35937 0.266468 5.27352 0.227833C5.18767 0.189198 5.09461 0.16922 5.00047 0.16922C4.90633 0.16922 4.81326 0.189198 4.72741 0.227833C4.64156 0.266468 4.56489 0.322882 4.50247 0.393345L0.652467 4.72335C0.270467 5.15335 0.5758 5.83334 1.15113 5.83334ZM4.5018 12.606C4.56423 12.6765 4.6409 12.7329 4.72675 12.7715C4.81259 12.8102 4.90566 12.8301 4.9998 12.8301C5.09394 12.8301 5.18701 12.8102 5.27285 12.7715C5.3587 12.7329 5.43537 12.6765 5.4978 12.606L9.34647 8.27601C9.72913 7.84668 9.4238 7.16668 8.84847 7.16668H1.15113C0.576467 7.16668 0.271133 7.84668 0.653133 8.27668L4.5018 12.606Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortOption);
export default __webpack_public_path__ + "static/media/sort-option.4adf6ec9c328b4228d08feb1f9abb08b.svg";
export { ForwardRef as ReactComponent };